const DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/;

export function formatUtcDate(value: Date): string {
  return value.toISOString().slice(0, 10);
}

/** Inclusive window ending today. 30 days is today plus the 29 days before it. */
export function defaultSearchQueryRange(today: Date): {
  from: string;
  to: string;
} {
  const to = formatUtcDate(today);
  const start = new Date(today.getTime());
  start.setUTCDate(start.getUTCDate() - 29);
  return { from: formatUtcDate(start), to };
}

export function searchQueryRangeError(from: string, to: string): string | null {
  if (!DATE_ONLY.test(from) || !DATE_ONLY.test(to)) {
    return 'Choose a start date and an end date';
  }
  if (from > to) {
    return 'Start date must be on or before the end date';
  }
  return null;
}
